import Markdown from 'markdown-to-jsx';
import * as React from 'react';
import { StyledHeadline, StyledSubHeadline, StyledSuperTinyHeadline, StyledSmallCapsHeadline, StyledParagraph } from './styles.js';

const MarkdownParser = ({ children , options , titleColor , paragraphColor , ...restProps })=>{
    const { overrides ={} , ...restOptions } = options ?? {};
    return /*#__PURE__*/ React.createElement(Markdown, {
        ...restProps,
        options: {
            ...restOptions,
            overrides: {
                ...overrides,
                h1: {
                    component: StyledHeadline,
                    props: {
                        titleColor,
                        className: "Headline"
                    }
                },
                h2: {
                    component: StyledSubHeadline,
                    props: {
                        titleColor,
                        className: "SubHeadline"
                    }
                },
                h3: {
                    component: StyledSuperTinyHeadline,
                    props: {
                        titleColor,
                        className: "SuperTinyHeadline"
                    }
                },
                h4: {
                    component: StyledSmallCapsHeadline,
                    props: {
                        titleColor,
                        className: "SmallCapsHeadline"
                    }
                },
                p: {
                    component: StyledParagraph,
                    props: {
                        paragraphColor,
                        className: "Paragraph"
                    }
                }
            }
        }
    }, children);
};

export { MarkdownParser };
